import { PRACTICE_NAME, PRACTICE_LOCATION, IDLE_LOCK_MINUTES, DEMO_MODE } from "../lib/config";

export function SettingsPage() {
  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1 className="page__title">Settings</h1>
          <p className="page__sub">Practice info, staff, and lender configuration.</p>
        </div>
      </div>

      <section className="card" style={{ marginBottom: 24 }}>
        <div className="card__row">
          <div className="card__row-meta">
            <span className="card__row-title">Practice</span>
            <span className="card__row-sub">
              {PRACTICE_NAME} — {PRACTICE_LOCATION}
            </span>
          </div>
        </div>
        <div className="card__row">
          <div className="card__row-meta">
            <span className="card__row-title">Auto-lock</span>
            <span className="card__row-sub">{IDLE_LOCK_MINUTES} minutes idle</span>
          </div>
        </div>
        <div className="card__row">
          <div className="card__row-meta">
            <span className="card__row-title">Auth</span>
            <span className="card__row-sub">
              {DEMO_MODE ? "Demo mode (auth disabled)" : "Email + password (HS256 JWT)"}
            </span>
          </div>
        </div>
      </section>

      <section>
        <h2 className="left__title" style={{ marginBottom: 8 }}>Staff and lenders</h2>
        <p className="page__sub" style={{ marginBottom: 16 }}>
          Staff list, lender description / tip / required-fields configuration. Backend-driven —
          coming after v1 launch. For now, lender config is hard-coded in <code>lib/demoData.ts</code>.
        </p>
      </section>
    </div>
  );
}
